<template>
	<div class="scroller">
		<div class="left" v-if='showArrow'>
			<div @click='scroll("left")'>
				<slot name='left'>
					<div class="button btn">
						<Icon :size='arrowSize' color='#B176C5' type="ios-arrow-back" />
					</div>
				</slot>
				
			</div>	
		</div>
		<div  class='container' id='scroll' @wheel='wheel' ref='scoller'>
			<slot></slot>
		</div>
		<div class="right" v-if='showArrow'>
			<div @click='scroll("right")'>
				<slot name='right'>
					<div class="button btn">
						<Icon :size='arrowSize' color='#B176C5' type="ios-arrow-forward" />
					</div>
				</slot>
			</div>
		</div>
	</div>
	
</template>

<script>
export default {
	data(){
		return {
			o_scrollLeft:0,
       	}
	},
	props:{
		unitWidth:{
			type:Number,
			default:0,
		},
		wheelEnable:{
			type:Boolean,
			default:false,
		},
		showArrow:{
			type:Boolean,
			default:true,
		}
	},
	components:{
		
	},
	created(){
	},
	computed: {
		arrowSize(){
			if (document.body.clientWidth <= 768) {
				return 20
			}
			return 50
		}
    },
	watch:{
	},
	methods:{
		scroll(direction){
			this.o_scrollLeft = this.$refs.scoller.scrollLeft
			this.animate()
			if (direction === 'left') {
				this.animate(-1)
			}else{
				this.animate(1)
			}
		},
		scrollToEnd(){
			this.$refs.scoller.scrollLeft = this.$refs.scoller.scrollWidth - this.$refs.scoller.clientWidth
		},
		animate(direction){
			requestAnimationFrame(()=>{
				if (direction == 1) {
					if (this.$refs.scoller.scrollLeft >= this.$refs.scoller.scrollWidth - this.$refs.scoller.clientWidth) return
					let value = this.unitWidth / 30 + this.$refs.scoller.scrollLeft
					if (value < this.o_scrollLeft + this.unitWidth) {
						this.$refs.scoller.scrollLeft = value
						this.animate(direction);
					} else {
						this.$refs.scoller.scrollLeft  = this.o_scrollLeft + this.unitWidth
					}
				} else if(direction == -1) {
					if (this.$refs.scoller.scrollLeft <= 0) return
					let value = this.$refs.scoller.scrollLeft - this.unitWidth / 30
					if (value > this.o_scrollLeft - this.unitWidth) {
						this.$refs.scoller.scrollLeft = value
						this.animate(direction);
					} else {
						this.$refs.scoller.scrollLeft  = this.o_scrollLeft - this.unitWidth
					}
				}
				
		  	})  
		},
		wheel(event){
			if (Math.abs(event.deltaX) > Math.abs(event.deltaY) && !this.wheelEnable) {
				event.stopPropagation();
				event.preventDefault();
			}
		}
	},
}
</script>

<style lang="scss" scoped>
	@import '@/style/mixin';
	@import '@/style/common';
	// /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: transparent;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background-color: transparent;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: transparent;
}
.scroller {
	display: flex;
	justify-content: center;
	align-items: center;
}
.left,.right {
	width: 0.8rem;
	display: flex;
	.btn {
		border: 1px solid #eee;
		border-radius: 40px;
	}
}
.right {
	justify-content: flex-end;
}
.container {
	scrollbar-width: none;
	flex:1;
	overflow-x: scroll;
	display: flex;
}

</style>